<template>
  <div ref="videoEmbedRef" class="video-embed">
    <VideoComponent
      :src="src"
      :video-type="model.state.settings.videoType"
      :controls="model.state.settings.controls"
      :height="model.state.settings.custom.videoHeight"
      :width="model.state.settings.custom.videoWidth"
      :alignment="model.state.settings.custom.align"
      :background-color="model.state.settings.backgroundColor"
      :loop="model.state.settings.loop"
      :autoplay="model.state.settings.autoplay"
      :sound="model.state.settings.sound"
      :video-url="model.state.settings.videoUrl"
      :opacity="model.state.settings.videoOpacity"
      :model-id="model.getSection().state.id"
      @ended="
        () => {
          model.state.settings?.actionEnded?.triggerAction(model);
        }
      "
    />
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import type { AddonVideoEmbedModel } from '@/src/components/addons/video-embed/Model';
import { applyReplacementTags } from '@/src/utilities/Utilities';
import VideoComponent from '@/src/components/components/video/VideoComponent.vue';

export default defineComponent({
  name: 'AddonVideoEmbed',
  components: { VideoComponent },
  inheritAttrs: false,
  props: {
    model: {
      type: Object as PropType<AddonVideoEmbedModel>,
      required: true
    }
  },
  setup(props) {
    const src = computed(() => {
      return applyReplacementTags(props.model.state.settings.videoUrl ?? '', props.model.column?.replacementTags);
    });

    return {
      src
    };
  }
});
</script>
